export class ComboDetails {
    public productName: string;
    public position: number;
    public currentValue: any;
    public newValue: any;
    public prevValue: any;
    public action: any;
    public corp: any;
    public wfinDate: any;
    public type: any;
    constructor(){
        this.productName = null;
        this.position = null;
        this.currentValue = null;
        this.newValue = null;
        this.prevValue = null;
        this.action = null;
        this.corp= null;
        this.wfinDate =null;
        this.type = null;
    }

}
